import React from 'react';
import { useLocation } from 'react-router-dom';

const MobileTextPage = () => {
  const location = useLocation();
  const { title, text } = location.state || {};

  if (!text) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <p style={{ fontWeight: 700, fontSize: '14px' }}>No details available.</p>
      </div>
    );
  }

  return (
    <div>
      {title && <h2 style={{ fontSize: '22px', fontWeight: 700, marginBottom: '10px' }}>{title}</h2>}
      <p style={{ fontSize: '15px', textAlign: 'justify', color: '#333' }}>{text}</p>
    </div>
  );
};

export default MobileTextPage;
